import { useDialog } from "../../hooks/useDialog"

export const Alert = ({data}) => {

    const dialog = useDialog()

    return (
        <>
        <span className="ti ti-warning"></span>
        <p>{data.message || "Ha ocurrido un error inesperado"}</p>
        <div className="actions-container">
            <button 
                type="button" 
                className="btn rmb-btn-primary" 
                onClick={() => dialog.close()}
            >
                Cerrar
            </button>
        </div>
        </>
    )
}